import * as React from 'react';
import * as style from './PromoBanner.css';
import classnames from 'classnames';
import { LinkButton, UIHeading1, UIHeading2, useDeviceType } from '@cian/ui-kit';

export const PromoBanner: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={classnames(style['container'], device === 'phone' && style['container-mobile'])}>
      <div className={style['wrapper']}>
        <div className={style['textblock']}>
          <div className={style['title']}>
            <UIHeading1 color="white_100">Циан для профи</UIHeading1>
          </div>
          <div className={style['text']}>
            <UIHeading2 color="white_100">Используйте возможности всех сервисов для решения ваших задач</UIHeading2>
          </div>
          <LinkButton
            href="https://promo.cian.ru/profi?utm_source=landing&utm_term=b2b&utm_campaign=rating"
            theme="fill_primary"
            target="_blank"
          >
            Подробнее
          </LinkButton>
        </div>
        <div className={style['image']} />
      </div>
    </div>
  );
};
